// 应用菜单
const menuData = {
  iconClass: "el-icon-s-home",
  menuName: "权限管理",
  children: [
    {
      path: "/rhqy/pri/app/index",
      menuName: "权限组配置",
      privilege: "c-role-full-mgr",
      iconClass: "el-icon-s-check"
    },
    // {
    //   path: "/rhqy/pri/admin",
    //   menuName: "指定管理员",
    //   privilege: "main-role-full-mgr",
    //   iconClass: "icon-rh-safe"
    // }
  ]
};

export { menuData };
